import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ssrFor, spaLinkHandler } from '../lib/ssrContent';

// WO-42: pages whose content is built by the api (lilycove-api services/seo_hubs.py): /stores, /stores/<province>,
// /store/<host>, /sets/<id>/most-valuable and /methodology. The first load shows the server-rendered HTML that came
// with the page; client-side navigation fetches the same HTML from /api/seo/page.
function bodyOf(html) {
  if (typeof document === 'undefined') return html;
  const t = document.createElement('template');
  t.innerHTML = html;
  const main = t.content.querySelector('#lc-seo-summary');
  return main ? main.innerHTML : html;
}

export default function ServerPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const ssr = ssrFor(pathname);
  const [state, setState] = useState(() => (ssr && ssr.body ? { status: 'ok', html: ssr.body } : { status: 'loading' }));

  useEffect(() => {
    const first = ssrFor(pathname);
    if (first && first.body) {
      setState({ status: 'ok', html: first.body });
      return undefined;
    }
    const ctrl = new AbortController();
    const apiUrl = process.env.REACT_APP_API_URL || '';
    setState({ status: 'loading' });
    fetch(`${apiUrl}/api/seo/page?path=${encodeURIComponent(pathname)}`, { signal: ctrl.signal })
      .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok || !d.html) { setState({ status: ok ? 'notfound' : (d && d.status === 404 ? 'notfound' : 'error') }); return; }
        if (d.title) document.title = d.title;
        setState({ status: 'ok', html: bodyOf(d.html) });
      })
      .catch((e) => { if (e.name !== 'AbortError') setState({ status: 'error' }); });
    return () => ctrl.abort();
  }, [pathname]);

  if (state.status === 'loading') return <div className="text-cream/60">Loading…</div>;
  if (state.status !== 'ok') {
    return (
      <div className="text-cream">
        <h1 className="text-2xl font-bold mb-2">{state.status === 'notfound' ? 'Page not found' : 'Could not load this page'}</h1>
        <Link to="/" className="underline">Back to Lilycove</Link>
      </div>
    );
  }
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="lc-server-content" onClick={spaLinkHandler(navigate)} dangerouslySetInnerHTML={{ __html: state.html }} />
  );
}
